import React from 'react';
import { ActionButton } from 'web-ui-components/lib/actions/buttons';
import { Content } from '../../../infrastructure/content';
import PropTypes from '../../../types';

const TaxRemoveLink = ({ onRemoveOne }) => (
  <Content>
    {({ removeButton = '' }) => (
      <ActionButton.Remove onClick={onRemoveOne} labelText={removeButton} />
    )}
  </Content>
);

TaxRemoveLink.propTypes = {
  onRemoveOne: PropTypes.func.isRequired
};

export default TaxRemoveLink;
